<div class="form-container">
  <form [formGroup]="contactSupportForm">
    <div class="form-group" style="display: flex; align-items: center;">
      <label style="margin-right: 10px;" class="label-required display"><b>To Email</b></label>
      <input type="email" formControlName="email" placeholder="support@example.com"
        [readonly]="contactSupportForm.get('useDefaultEmail')?.value"
        [ngClass]="{ 'is-invalid': submitted && formControls.email.invalid }" />
      <label style="margin-left: 10px; display: flex; align-items: center; cursor: pointer;">
        <input type="checkbox" formControlName="useDefaultEmail" />Use default email
      </label>
    </div>

    <div class="form-group">
      <label class="label-required display"><b>Mobile</b></label>
      <input type="tel" formControlName="mobile" placeholder="Enter mobile number" required minlength="10"
        maxlength="10" [ngClass]="{ 'is-invalid': submitted && formControls.mobile.invalid }" />

    </div>

    <div class="form-group">
      <label class="label-required display"><b>Subject</b></label>
      <input formControlName="subject" placeholder="Enter subject" required
        [ngClass]="{'is-invalid ng-dirty': submitted && formControls.subject.errors }" />
    </div>

    <div class="form-group">
      <label><b>Description</b></label>
      <textarea formControlName="description" placeholder="Enter description"></textarea>
    </div>

    <div class="form-group">
      <label><b>Attachment</b></label>
      <input type="file" (change)="onFileChange($event)"
        accept=".pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, image/*, video/*" />
    </div>

    <div class="form-group">
      <label><b>How critical is your request?</b></label>
      <select formControlName="urgency">
        <option value="">None</option>
        <option value="Low">Low</option>
        <option value="Medium">Medium</option>
        <option value="High">High</option>
      </select>
    </div>

    <button type="submit" class="submit-btn" (click)="onSubmit()"><b>SUBMIT</b></button>
  </form>
</div>
<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
<app-loader *ngIf="loader"></app-loader>